interface ScoreCircleProps {
  score: number;
  title?: string;
}

export const ScoreCircle = ({ score }: ScoreCircleProps) => {
  const radius = 90;
  const circumference = 2 * Math.PI * radius;
  const roundedScore = Math.round(score);
  const strokeDashoffset = circumference - (roundedScore / 100) * circumference;
  const strokeWidth = 30;

  const getScoreColor = (score: number) => {
    if (score <= 20) return '#f75d49';
    if (score <= 60) return '#f0c761';
    return '#22c55e';
  };

  return (
    <div className="flex flex-col items-center" style={{ width: '225px', height: '225px' }}>
      <div className="relative w-[225px] h-[225px] flex items-center justify-center">
        <svg
          className="w-full h-full transform -rotate-90"
          viewBox="0 0 225 225"
          style={{ width: '225px', height: '225px' }}
        >
          {/* Background circle */}
          <circle
            cx="112.5"
            cy="112.5"
            r={radius}
            fill="none"
            stroke="#E5E7EB"
            strokeWidth={strokeWidth}
          />
          {/* Progress circle */}
          <circle
            cx="112.5"
            cy="112.5"
            r={radius}
            fill="none"
            stroke={getScoreColor(roundedScore)}
            strokeWidth={strokeWidth}
            strokeLinecap="round"
            style={{
              strokeDasharray: circumference,
              strokeDashoffset: strokeDashoffset,
              transition: 'stroke-dashoffset 0.5s ease-in-out, stroke 0.5s ease-in-out'
            }}
          />
        </svg>
        <div className="absolute inset-0 flex items-center justify-center">
          <span className="text-6xl font-light">{roundedScore}</span>
        </div>
      </div>
    </div>
  );
};